<svelte:component
    this="{ InputComponent }"
    {id}
    {type}
    {required}
    {value}
    {options}
    {error}
    {touched}
    {isLoading}
    on:change="fire('change', { id: id, value: event.value })"
    on:blur="blur()"
/>

<script>
    import Base from './inputs/Base.html';
    import Checkbox from './inputs/Checkbox.html';
    import Submit from './inputs/Submit.html';

    export default {

        data() {
            return {
                id: null,
                type: null,
                value: '',
                required: false,
                touched: false,
                options: {}
            }
        },

        computed: {

            InputComponent: ({ type }) => {
                if(type === 'checkbox') return Checkbox;
                if(type === 'submit') return Submit;

                return Base;
            },

            required: ({ options }) => {
                if (!options.rules) {
                    return false;
                }

                if (Array.isArray(options.rules)) {
                    return options.rules.includes('required');
                }

                return Object.values(options.rules).includes('required');
            },

            error: ({ options }) => {
                return options.error;
            },

        },

        methods: {

            blur() {
                this.fire('blur');
                this.set({
                    touched: true,
                });
            }

        }

    }
</script>
